import { Environment } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { useObservableEagerState } from 'observable-hooks'
import { useEffect } from 'react'

import { anchorPointsService } from '../systems/anchor-points-service'
import { MeasurementIndicator } from '../ui/MeasurementIndicator'

export const AppEnvironment = () => {
  const { measurementToolSourceId, measurementToolDestinationId } = useObservableEagerState(anchorPointsService.state$)

  const { gl } = useThree()
  useEffect(() => {
    gl.toneMappingExposure = 1
  }, [gl])

  return (
    <>
      <directionalLight intensity={0.4} position={[2, 1, 4]} />
      <directionalLight intensity={0.4} position={[-2, 1, -4]} />
      <Environment files="./environments/interior_haussmannian_front_day_light_05.hdr" />

      {measurementToolSourceId && measurementToolDestinationId && (
        <MeasurementIndicator
          anchorPointIdFrom={measurementToolSourceId}
          anchorPointIdTo={measurementToolDestinationId}
        />
      )}
    </>
  )
}
